import { render, staticRenderFns } from "./Restaurante.vue?vue&type=template&id=41efcc72&lang=pug&"
import script from "./Restaurante.vue?vue&type=script&lang=ts&"
export * from "./Restaurante.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports